$(document).on('turbolinks:load', function () {
  var savedGridRowAmount = localStorage.getItem('gridRowAmount')
  var $gridImgButton = $('.js-grid-img');
  var $productWrapper = $('.js-product-wrapper');

  // Restore state from localStorage
  if (savedGridRowAmount) {
    $gridImgButton.removeClass('active-row-columns-list');
    $gridImgButton.each(function () {
      if ($(this).parent().data('row-amount') == savedGridRowAmount) {
        $(this).addClass('active-row-columns-list');
      }
    });
  }
  
  if (savedGridRowAmount == 4) {
    $productWrapper.each(function () {
      $(this).removeClass('col-sm-6 col-md-6 col-lg-4').addClass('col-sm-6 col-md-4 col-lg-3');
    });
  } else if (savedGridRowAmount == 3) {
    $productWrapper.each(function () {
      $(this).removeClass('col-sm-6 col-md-4 col-lg-3').addClass('col-sm-6 col-md-6 col-lg-4');
    });
  }

  // Handle click events
  $('.js-grid-img').on('click', function(e){
    e.preventDefault()
    var $productWrapper = $('.js-product-wrapper')
    var $gridAmount = $(this).parent().data('row-amount');

    $('.js-grid-img').removeClass('active-row-columns-list')
    $(this).addClass('active-row-columns-list')

    if ($gridAmount == 4){
      $productWrapper.each(function() {
        $(this).removeClass('col-sm-6 col-md-6 col-lg-4').addClass('col-sm-6 col-md-4 col-lg-3');
        localStorage.setItem('gridRowAmount', $gridAmount);
      });
    } else if ($gridAmount == 3){
      $productWrapper.each(function() {
        $(this).removeClass('col-sm-6 col-md-4 col-lg-3').addClass('col-sm-6 col-md-6 col-lg-4');
        localStorage.setItem('gridRowAmount', $gridAmount);
      });
    }
  })
});
